import Vue from 'vue'
import Router from 'vue-router'
import VueBus from 'vue-bus';
Vue.use(VueBus);
// import UserCenter from '@/components/UserCenter'
// import HomePage from '@/components/HomePage'
// import SignIn from '@/components/SignIn'
// import Register from '@/components/Register'
// import ForgotPassword from '@/components/ForgotPassword'
// import SocialRecruitment from '@/components/SocialRecruitment'
// import RecruitmentDetails from '@/components/RecruitmentDetails'
// import RecruitmentList from '@/components/RecruitmentList'
// import MyResume from '@/components/MyResume'
// import MyRecommend from '@/components/MyRecommend'
// import MyApply from '@/components/MyApply'
// import MyCollection from '@/components/MyCollection'

const HomePage = () => import('@/components/HomePage');
// const IndexPage = () => import('@/components/IndexPage');
// const JobList = () => import('@/components/JobList')
// const dynamic = () => import('@/components/dynamic')
// const process = () => import('@/components/process')
// const personal = () => import('@/components/personal')
// const Apply = () => import('@/components/MyApply')
// const Resume = () => import('@/components/MyResume')
// const loginPage = () => import('@/components/loginPage')
// const login = () => import('@/components/login')
// const register = () => import('@/components/register')
// const forget = () => import('@/components/forget')
// const knowStar = () => import('@/components/knowStar')
// const knowRedstar = () => import('@/components/knowRedstar')
// const star = () => import('@/components/star')
// const companyIntro = () => import ('@/components/companyIntro')
// const culture = () => import('@/components/culture')
// const projectIntro = () => import('@/components/projectIntro')
// const spirit = () => import('@/components/spirit')
import { MessageBox } from 'mint-ui';
Vue.use(Router);
const router = new Router({
  //mode: 'history',
  base:'/campus',
  fallback: false,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },{
      path: '/success',
      name: 'success',
      component: resolve => require(['@/components/success'],resolve),
  },{
      path: '/home',
      name: 'IndexPage',
      //component: IndexPage,
      component:resolve => require(['@/components/IndexPage'],resolve),
          children:[{
          path: '/joblist',
          name: 'joblist',
          //component: JobList,
          component:resolve => require(['@/components/JobList'],resolve),
      },{
          path: '/jobdetail/:id',
          name: 'jobdetail',
          //component: JobList,
          component:resolve => require(['@/components/JobDetail'],resolve),

      },{
          path: '/qa',
          name: 'dynamic',
          component:resolve => require(['@/components/dynamic'],resolve),
          //component: dynamic,
      },{
          path: '/process',
          name: 'process',
          component:resolve => require(['@/components/process'],resolve),
          //component: process,
      },{
          path: '/personal',
          name: 'personal',
          component:resolve => require(['@/components/personal'],resolve),
          //component: personal,
          children:[{
              path: '/personal',
              name: 'apply',
              component:resolve => require(['@/components/MyApply'],resolve),
              //component: Apply
          },]
      },{
          path: '/resume',
          name: 'resume',
          component:resolve => require(['@/components/MyResume'],resolve),
          //component: Resume
      },{
          path: '/apply',
          name: 'apply',
          component:resolve => require(['@/components/MyApply'],resolve),
          //component: Apply
      },{
          path: '/companyIntro',
          name: 'knowStar',
          component:resolve => require(['@/components/star'],resolve),
          //component: knowStar,
          children:[{
              path: '/projectIntro',
              name: 'projectIntro',
              component:resolve => require(['@/components/projectIntro'],resolve),
              //component: projectIntro,
          },{
              path: '/spirit',
              name: 'spirit',
              component:resolve => require(['@/components/spirit'],resolve),
              //component: spirit,
          },{
              path: '/companyIntro',
              name: 'companyIntro',
              component:resolve => require(['@/components/companyIntro'],resolve),
              //component: companyIntro,
          },{
              path: '/culture',
              name: 'culture',
              component:resolve => require(['@/components/culture'],resolve),
              //component: culture,
          }]
        }]
      },{
          path: '/loginPage',
          name: 'loginPage',
          component:resolve => require(['@/components/loginPage'],resolve),
          //component: loginPage,
          children:[]
      },{
          path: '/login',
          name: 'login',
          component:resolve => require(['@/components/login'],resolve),
          //component: login,
      },{
          path: '/codeLogin',
          name: 'codeLogin',
          component:resolve => require(['@/components/codeLogin'],resolve),
          //component: login,
      },{
          path: '/register',
          name: 'register',
          component:resolve => require(['@/components/register'],resolve),
          //component: register,
      },{
          path: '/forget',
          name: 'forget',
          component:resolve => require(['@/components/forget'],resolve),
          //component: forget,
      }]
});
export default router;

router.afterEach(route => {
    MessageBox.close();
})


// WEBPACK FOOTER //
// ./src/modules/index/router/index.js